import React from "react";
import { useHistory } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Button as CustomButton } from "components/Buttons";

import { useAppSelector } from "hooks/reduxHooks";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { USER_GROUPS } from "constants/roles";
import { Clinician } from "types/Clinician";
import { PAGES } from "constants/pages";
import { ButtonColorScheme, ButtonType } from "types/ui";

const SuperAdminOverview = () => {
  const currentClinician: Clinician | undefined = useAppSelector(
    selectCurrentClinician
  );
  const history = useHistory();

  return (
    <div className="container max-w-[85%] m-auto pt-[40px]">
      {currentClinician?.role?.includes(USER_GROUPS.SUPER_ADMIN) && (
        <Grid
          container
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          mt="100px"
          mb="12px"
        >
          <h1 id="superadmintitle">
            <Grid container>Welcome</Grid>
          </h1>

          <Grid>Select one of the navigation options below</Grid>
          <Grid container gap="20px" justifyContent="center" mt="40px">
            <CustomButton
              title="Athletic"
              onClick={() => {
                history.push(PAGES.athleteOverview);
              }}
              type={ButtonType.normal}
              colorScheme={ButtonColorScheme.gradient}
              shadowed
            />

            <CustomButton
              title="Clinical"
              onClick={() => {
                history.push(PAGES.clinicOverview);
              }}
              type={ButtonType.normal}
              colorScheme={ButtonColorScheme.gradient}
              shadowed
            />
          </Grid>
        </Grid>
      )}
    </div>
  );
};

export default SuperAdminOverview;
